export default "__VITE_ASSET__DlNpquDI__"